import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ChevronLeft, ShieldCheck, Loader2 } from 'lucide-react';
import { API } from '@/lib/api';
import axios from 'axios';
import { LEGAL_DOCS, COMPANY } from './legalContent';

export default function LegalDoc() {
  const { slug } = useParams();
  const nav = useNavigate();
  const fallback = LEGAL_DOCS[slug];
  const [doc, setDoc] = useState(fallback || null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/policies/${slug}`)
      .then(r => setDoc(r.data))
      .catch(() => setDoc(fallback || null))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading && !doc) {
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground"><Loader2 className="w-5 h-5 animate-spin" /></div>;
  }
  if (!doc) {
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground" data-testid="legal-not-found">Document not found.</div>;
  }

  return (
    <div className="min-h-screen bg-regen-bg text-foreground" data-testid={`legal-${slug}`}>
      <div className="max-w-3xl mx-auto px-6 py-10">
        <button onClick={() => (window.history.length > 1 ? nav(-1) : nav('/'))} data-testid="legal-back" className="text-muted-foreground hover:text-foreground inline-flex items-center gap-2 text-sm mb-6"><ChevronLeft className="w-4 h-4" /> Back</button>
        <div className="flex items-center gap-2 mb-1"><ShieldCheck className="w-5 h-5 text-[#00C8FF]" /><span className="label-mini text-[#00C8FF]">YourReGen Legal</span></div>
        <h1 className="font-display font-black text-3xl tracking-tight">{doc.title}</h1>
        <p className="text-xs text-muted-foreground mt-1">Version {doc.version} · {COMPANY.legal_name}</p>

        <div className="mt-8 space-y-6">
          {(doc.body || []).map(([heading, text], i) => (
            <section key={i}>
              <h2 className="font-display font-bold text-lg text-foreground">{heading}</h2>
              <p className="text-sm text-foreground/80 leading-relaxed mt-1.5">{text}</p>
            </section>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-[var(--c-hair)] text-xs text-muted-foreground">
          {COMPANY.legal_name} · {COMPANY.address} · {COMPANY.privacy_email}
        </div>
      </div>
    </div>
  );
}
